import React, { ReactNode } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css, Global } from '@emotion/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { web_max_width } from '@common/styles';

export interface BaseLayoutProps {
  children: ReactNode;
}
export function BaseLayout({ children }: BaseLayoutProps) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { gcTime: 300000, refetchOnWindowFocus: false, staleTime: 300000, retry: 1 } },
      }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <Global
        styles={css`
          #__next,
          #root {
            max-width: ${web_max_width}px;
            width: 100%;
            height: auto;
            background: ${vars.color.backgroundSurface};
            margin: 0 auto;
          }
          a,
          button {
            cursor: pointer;
            transition:
              background 0.25s cubic-bezier(0.33, 1, 0.68, 1),
              color 0.25s cubic-bezier(0.33, 1, 0.68, 1);
            :active {
              background: ${vars.color.blackOpacity5};
            }
          }
        `}
      />
      {children}
    </QueryClientProvider>
  );
}
